import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

import { Title } from "@/components/Typography";
import { NAMESPACES } from "@/constants/i18next.constants";

import { useBillingOnboardingStore } from "../BillingOnboardingModal";
import { useFirstBillingModalStore } from "./FirstBillingModal.store";
import {
  Container, Description, LummyLogo, ModalStyled,
} from "./FirstBillingModal.styles";

function FirstBillingModal() {
  const { isModalOpen, setIsModalOpen } = useFirstBillingModalStore(
    useShallow(state => ({
      isModalOpen: state.isModalOpen,
      setIsModalOpen: state.setIsModalOpen,
    })),
  );

  const toggleBillingOnboardingModal = useBillingOnboardingStore(
    state => state.toggleModal,
  );

  const { t } = useTranslation(NAMESPACES.BILLING_ONBOARDING);

  const handleOnOk = () => {
    setIsModalOpen(true);
    toggleBillingOnboardingModal();
  };

  return (
    <ModalStyled
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      okText={t("firstBillingModal.okText")}
      onOk={handleOnOk}
      cancelText={t("firstBillingModal.cancelText")}
      width={420}
      centered
    >
      <LummyLogo>
        <img
          src={new URL("@/assets/lumian/lummy-with-paper.png", import.meta.url).href}
          alt="lummy logo"
          width="316"
          height="206"
        />
      </LummyLogo>
      <Container>
        <Title level={2} variant="medium" weight="semiBold">
          {t("firstBillingModal.title")}
        </Title>
        <Description>
          {t("firstBillingModal.description")}
        </Description>
      </Container>
    </ModalStyled>
  );
}

export default FirstBillingModal;
